import {DownloadOutlined} from '@ant-design/icons';
import {Button, Space} from 'antd';
import api from '../../api';

const normalizeFilenamePart = value => {
  const replacements = {
    Ä: 'Ae',
    Ö: 'Oe',
    Ü: 'Ue',
    ä: 'ae',
    ö: 'oe',
    ü: 'ue',
    ß: 'ss',
  };
  return (value || 'BUEV-Export')
    .replace(/[ÄÖÜäöüß]/g, match => replacements[match])
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'BUEV-Export';
}

const ReportsLinks = ({searchParams}) => {

  const meetingFilename = normalizeFilenamePart(searchParams.meetingName);

  const getMembersCsv = e => {
    api.report.membersCsv({
      filename: `members-${searchParams.meeting}.csv`,
      params: {
        meeting: searchParams.meeting,
      }
    });
  }

  const getMembersXlsx = e => {
    api.report.membersXlsx({
      filename: `${meetingFilename}-Teilnehmer.xlsx`,
      params: {
        meeting: searchParams.meeting,
      }
    });
  }

  const getProgramMembersCsv = e => {
    api.report.programMembersCsv({
      filename: `members-${searchParams.meeting}.csv`,
      params: {
        meeting: searchParams.meeting,
        special_program: searchParams.specialProgram,
        accompany_program: searchParams.accompanyProgram,
        evening_program: searchParams.eveningProgram,
        parking_pass: searchParams.parkingPass
      }
    });
  }

  const getProgramMembersXlsx = e => {
    api.report.programMembersXlsx({
      filename: `${meetingFilename}-Programm.xlsx`,
      params: {
        meeting: searchParams.meeting,
        special_program: searchParams.specialProgram,
        accompany_program: searchParams.accompanyProgram,
        evening_program: searchParams.eveningProgram,
        parking_pass: searchParams.parkingPass
      }
    });
  }

  const getMembers = e => {
    api.report.membersPdf({
      filename: `members-${searchParams.meeting}.pdf`,
      params: {
        meeting: searchParams.meeting,
      }
    });
  }

  const getReport = e => {
    api.report.listOfSigns({
      filename: `unterschriftenliste-${searchParams.meeting}.pdf`,
      params: {
        meeting: searchParams.meeting,
        special_program: searchParams.specialProgram,
        accompany_program: searchParams.accompanyProgram,
        evening_program: searchParams.eveningProgram
      }
    });
  }

  const getBadges = e => {
    api.report['badges']({
      filename: `namensschilder-${searchParams.meeting}.pdf`,
      params: {
        meeting: searchParams.meeting,
        special_program: searchParams.specialProgram
      }
    });
  }

  return <div>
    <hr className="hr"/>
    <div style={{marginBottom: '20px'}}><Space>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getReport}>
        Unterschriftenliste {searchParams.specialProgram && 'Begleitprogramm'}
      </Button>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getBadges}>
        Namensschilder {searchParams.specialProgram && 'Begleitprogramm'}
      </Button>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getMembers}>
        Teilnehmer
      </Button>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getMembersCsv}>
        CSV {searchParams.specialProgram}
      </Button>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getMembersXlsx}>
        Teilnehmer XLSX
      </Button>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getProgramMembersCsv}>
        Programm CSV
      </Button>
      <Button shape="round" icon={<DownloadOutlined/>} onClick={getProgramMembersXlsx}>
        Programm XLSX
      </Button>
    </Space></div>
    <hr className="hr"/>
  </div>;
}

export default ReportsLinks;
